export default __webpack_public_path__ + "static/media/decorative-image-5.13fdab5c.jpg";